import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Chatbot } from "react-chatbot-kit";
import { Fab } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import CloseIcon from "@mui/icons-material/Close";

import { useLazyTalkChatbotQuery } from "../features/bot/chatbot.api";
import config from "../config/chatbot.config";
import { MessageParser } from "../utils/message-parser";
import { ActionProvider } from "../utils/action-provider";
import COLORS from "../colors/colors";
import "react-chatbot-kit/build/main.css";
import "../assets/css/styles.chatbot.scss";

const ChatbotWidget = () => {
  const user = useSelector((state) => state.user);
  const [triggerTransactionLookup] = useLazyTalkChatbotQuery();
  const [isOpen, setIsOpen] = useState(false);
  const isPermittedToUseChatbot = user?.permissions?.includes(88);

  useEffect(() => {
    const interval = setInterval(() => {
      const sendButton = document.querySelector(".react-chatbot-kit-chat-btn-send");
      const inputField = document.querySelector(".react-chatbot-kit-chat-input");

      if (sendButton && inputField) {
        // Avoid adding multiple listeners
        if (!sendButton.getAttribute("data-hooked")) {
          sendButton.setAttribute("data-hooked", "true");

          sendButton.addEventListener("click", (e) => {
            if (inputField instanceof HTMLInputElement) {
              const value = inputField.value.trim();
              if (value === "") {
                e.stopPropagation();
                e.preventDefault();
              }
            }
          });
        }
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {isOpen && isPermittedToUseChatbot && (
        <div className="fisto-chatbot-box">
          <Chatbot
            config={config}
            messageParser={MessageParser}
            actionProvider={(createChatBotMessage, setStateFunc, createClientMessage, ...rest) =>
              new ActionProvider(
                createChatBotMessage,
                setStateFunc,
                createClientMessage,
                triggerTransactionLookup // <-- Your custom function
              )
            }
          />
        </div>
      )}

      {isPermittedToUseChatbot && (
        <Fab
          className="fisto-chatbot-fab"
          onClick={() => setIsOpen((prev) => !prev)}
          sx={{
            position: "fixed",
            bottom: 60,
            right: 24,
            backgroundColor: COLORS.SECONDARY_COLOR,
            "&:hover": { backgroundColor: COLORS.ACCENT_HOVER_DARK_COLOR },
            zIndex: 1300,
          }}
        >
          {isOpen ? <CloseIcon sx={{ color: "white" }} /> : <ChatIcon sx={{ color: "white" }} />}
        </Fab>
      )}
    </>
  );
};

export default ChatbotWidget;
